/**
 * Calculate Future Value
 *
 * @param rate The interest rate per period.
 * @param nper The total number of payment periods.
 * @param pmt The payment made each period. Must be entered as a negative number.
 * @param initial The present value of future payments. If omitted, assumed to be zero. Must be entered as a negative number.
 * @param type When payments are due. 0 = end of period, 1 = beginning of period. Default is 0.
 */

export const fv = (
  rate: number,
  nper: number,
  pmt: number,
  initial: number,
  type: number
): number => {
  if (rate === 0) {
    return -1 * (initial + pmt * nper);
  }
  return (
    (pmt * (1 + rate * type) * (1 - Math.pow(1 + rate, nper))) / rate -
    initial * Math.pow(1 + rate, nper)
  );
};
